import { render, staticRenderFns } from "./ModalShowRequestMaterials.vue?vue&type=template&id=4f722d60"
import script from "./ModalShowRequestMaterials.vue?vue&type=script&lang=js"
export * from "./ModalShowRequestMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports